import "react-loading-skeleton/dist/skeleton.css";

import React from "react";
import Skeleton from "react-loading-skeleton";

export const LoadingSkeleton = () => {
  return (
    <div className="row">
      <div className="col-sm-2 col-sm-offset-5">
        <Skeleton
          count={1}
          width="50px"
          height="50px"
          circle={true}
          containerTestId="react-loading-skeleton"
        />
      </div>
    </div>
  );
};
